import HTTP from "../http";
import Jsona from "jsona";

import newOrderHelper from "@/utils/helpers/newOrder";
import { setUser, captureException } from "@sentry/browser";
const dataFormatter = new Jsona();

export default {
  async index(page, sort) {
    try {
      let results = await HTTP.normal.get(
        `/orders?include=cycle,schedule_event,professional.account.profile,customer.account.profile,address.district.city.state&page[number]=${page}&sort=-created_at`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar os pedidos!";
    }
  },

  async show(id) {
    try {
      let results = await HTTP.normal.get(
        `/orders/${id}/?include=schedule_event,professional.account.profile,professional.account.schedule,customer.account.profile,address.district.city.state.country,payments.funding_instrument,amount.subtotal,coupon`
      );

      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar o pedido!";
    }
  },

  async create(payload) {
    try {
      let order = await HTTP.normal.post("/orders", payload);
      return dataFormatter.deserialize(order.data);
    } catch (e) {
      setUser({ email: state.user.email });
      captureException(e);
      throw "Ocorreu um erro ao criar o pedido!";
    }
  },

  async createOnGateway(order_id) {
    try {
      await HTTP.normal.post(`orders/${order_id}/create-on-gateway`);
    } catch (e) {
      throw e;
    }
  },

  async checkIfCouponApplies(payload) {
    try {
      let res = await HTTP.normal.get(
        `/orders/${payload.order}/check-if-coupon-applies?coupon_id=${
          payload.coupon
        }`
      );

      if (!res.data.data.passes_restrictions)
        throw "O cupom informado não pode ser aplicado à este pedido!";
    } catch (e) {
      throw e;
    }
  },

  async applyCoupon(payload) {
    try {
      let data = {
        data: {
          type: "orders",
          id: payload.order,
          relationships: {
            coupon: {
              data: {
                type: "coupons",
                id: payload.coupon
              }
            }
          }
        }
      };

      let order = await HTTP.normal.patch(
        `/orders/${payload.order}?include=coupon`,
        data
      );
      return dataFormatter.deserialize(order.data);
    } catch (e) {
      throw "Ocorreu um erro ao aplicar o cupom!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/orders.js